import { ReportType, ScopeReportLineItem } from '@kaiizen/kai-reports';
import { useNavigate, useParams } from 'react-router';
import { useNavigateToScan } from '../../State/kaiNavigation';

interface Scan {
  scanType?: string;
}

export const useReportNavigation = (
  scanId: string,
  reportType: ReportType,
  scan: Scan | undefined,
) => {
  const navigate = useNavigate();
  const navigateToScan = useNavigateToScan();
  const { groupId, taskId } = useParams();

  const getRouteSuffix = () => {
    switch (reportType) {
      case 'fullScope':
        return 'scope-preview';
      case 'changeOrder':
        return 'change-order-scope-preview';
      case 'punchlist':
        return 'punchlist-scope-preview';
      case 'closeout':
        return 'closeout-scope-preview';
      default:
        return 'scope-preview';
    }
  };

  const handleBack = () => {
    switch (reportType) {
      case 'fullScope':
        navigateToScan({ scanId, review: true });
        break;
      case 'changeOrder':
        navigateToScan({ scanId, review: true });
        break;
      case 'punchlist':
      case 'closeout': {
        if (groupId) {
          navigateToScan({ scanId, groupId, taskId });
        } else {
          navigate(`/scan/${scanId}/`);
        }
        break;
      }
      default:
        navigateToScan({ scanId, review: true });
    }
  };

  const handleSelected = async (item: ScopeReportLineItem) => {
    if (!item.groupId || !item.taskId) return;

    const routeSuffix = getRouteSuffix();
    const optionPath = item.optionId ? `/option/${item.optionId}` : '';
    const lineItemPath = item.lineItemId ? `/lineitem/${item.lineItemId}` : '';
    navigate(`/scan/${scanId}/${routeSuffix}/group/${item.groupId}/task/${item.taskId}${optionPath}${lineItemPath}`);

    if (['final', 'progress'].includes(scan?.scanType ?? '')) {
      navigateToScan({
        scanId,
        groupId: item.groupId,
        taskId: item.taskId,
      });
    } else {
      navigate(`/scan/${scanId}/group/${item.groupId}?taskId=${item.taskId}`);
    }
  };

  const handleLineItemClick = (event: React.MouseEvent<HTMLTableRowElement>, item: ScopeReportLineItem, lineItemId: string) => {
    handleSelected(item);
  };

  const handleGroupItemClick = async (groupId: string, taskId?: string) => {
    if (!groupId) return;

    const routeSuffix = getRouteSuffix();
    navigate(`/scan/${scanId}/${routeSuffix}/group/${groupId}`);

    if (['final', 'progress'].includes(scan?.scanType ?? '')) {
      navigateToScan({
        scanId,
        groupId,
      });
    } else {
      navigate(`/scan/${scanId}/group/${groupId}${taskId ? `?taskId=${taskId}` : ''}`);
    }
  };

  return {
    handleBack,
    handleSelected,
    handleLineItemClick,
    handleGroupItemClick,
  };
};
